import axios from "@/axios";
import JSEncrypt from "jsencrypt";

let publicKey = "";

export default {
  async getPublicKey() {
    return axios
      .post("/core/pu/common/public/get")
      .then((res) => {
        if (res.data.resType === "RES_OK") {
          publicKey = res.data.resMsg;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  // RSA 암호화
  encryptData(plainText) {
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey); // 서버에서 받은 공개키
    return jsEncrypt.encrypt(plainText);
  },
};
